import Tabs from './Tabs';
import Input from './Input';
import Layout from './layout';
import TableTheme from './Table';
import Buttons from './buttons';
import AutoComplete from './autoComplete';
import Dialogs from './dialog';
import Modal from './modal';
import Calendar from './calendar';
import Loader from './loader';
import selectInput from './select';
import MultilineInput from './multilineInput';
import Divider from './divider';
import Checkbox from './checkbox';
import Link from './MuiLink';
import Switch from './switch';
import Radio from './RadioButton';
import ToolTip from './tooltip';
import Chip from './chip';

// ==============================|| OVERRIDES - MAIN ||============================== //

export default function ComponentsOverrides(theme) {
  return {
    ...Tabs(theme),
    ...Input(theme),
    ...TableTheme(theme),
    ...Calendar(theme),
    ...Layout(theme),
    ...Buttons(theme),
    ...AutoComplete(theme),
    ...Dialogs(theme),
    ...Modal(theme),
    ...Loader(theme),
    ...selectInput(theme),
    ...MultilineInput(theme),
    ...Divider(theme),
    ...Checkbox(theme),
    ...Link(theme),
    ...Switch(theme),
    ...Radio(theme),
    ...ToolTip(theme),
    ...Chip(theme)
  };
}